import { twMerge } from 'tailwind-merge';
import { ISponsorIconProps } from '.';

export interface SponsorLinkProps {
  to: string;
  icon: React.ComponentType<ISponsorIconProps>;
  onClick?: React.MouseEventHandler;
  className?: string;
}

export const SponsorLink = ({ to, icon: Icon, onClick, className }: SponsorLinkProps) => {
  return (
    <a
      onClick={onClick}
      href={to}
      target="_blank"
      className={twMerge(
        'text-white opacity-80 transition-all duration-300 ease-in-out hover:text-lime hover:opacity-100',
        className,
      )}
    >
      <Icon className="h-full max-h-[50px] w-full max-w-[90px]" baseHue={0} baseLightness={0.5} baseSaturation={0} />
    </a>
  );
};
